import React from "react";

const RemixIco = () => {
  return (
    <head>
      <link
        href="https://cdn.jsdelivr.net/npm/remixicon@2.3.0/fonts/remixicon.css"
        rel="stylesheet"
      />
    </head>
  );
};

export default RemixIco;
